<template>
  <v-container fluid class="fill-height py-0">
    <v-row class="fill-height">
      <v-col cols="12" sm="12" mb="5" lg="5" class="d-flex justify-center align-center createccountbg">
        <!-- <v-img
          width="300px"
          class="mx-auto"
          src="../assets/packagepic4.png"
        ></v-img> -->
        <!-- <v-card class="cardsradius">
          <v-card-text> -->
            <v-row class="mx-5">
              <v-col cols="12" class="text-center">
                <h2 class="compeatfont white--text">
                  Sign up today to unlock a
                </h2>
                <h1 class="compeatfont mb-3 white--text">World of possibilities</h1>
                <v-divider class="mt-4" color="white"></v-divider>
              </v-col>
              <v-col cols="12" class="text-center white--text">
                <ol class="mb-4">
                  <li>
                    Gain instant access to our user-friendly dashboard when
                    creating your account.
                  </li>
                  <li>
                    Generate three complimentary demo reports of your choice.
                  </li>
                  <li>
                    Manage and monitor your subscriptions effortlessly with our
                    intuitive platform. Stay informed and in control as you view
                    and track all of your subscriptions seamlessly.
                  </li>
                </ol>
                <h3 class="compeatfont">
                  Don't miss out on this opportunity to explore our platform and
                  uncover valuable insights—register today and take your
                  strategy to the next level
                </h3>
              </v-col>
            </v-row>
          <!-- </v-card-text>
        </v-card> -->
      </v-col>
      <v-col cols="12" sm="12" mb="7" lg="7" class="text-center d-flex justify-center align-center">

        <v-card width="500px" class="mx-auto" flat>
          <v-card-text>
            <v-form ref="packageOneForm" v-model="packageOnevalid" class="my-3">
                <generalAlert  
                    :alert="alert"
                    :alertType="alertType"
                    :message="successResponse"
                />
              <v-row>
                {{ this.title }}
                <v-col cols="12">
                    <v-img
                        src="../assets/Compeat-Logo-website.png"
                        width="350px"
                        class="mx-auto mb-5"
                        />
                  <!-- <h2 class="compeatfont mb-3">Sign up now to create your account</h2> -->
                  <h2 class="compeatfont">Create Account</h2>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="12" class="py-0">
                  <v-text-field
                    dense
                    rounded
                    outlined
                    v-model="firstName"
                    label="First Name"
                    :rules="textRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="12" class="py-0">
                  <v-text-field
                    dense
                    rounded
                    outlined
                    v-model="lastName"
                    label="Last Name"
                    :rules="textRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="py-0">
                  <vue-tel-input-vuetify
                    dense
                    rounded
                    outlined
                    id="mobile"
                    v-model="mobile"
                    data-ref="mobile"
                    defaultCountry="za"
                    @input="onInput"
                    clearable
                    label=""
                  ></vue-tel-input-vuetify>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    dense
                    rounded
                    outlined
                    v-model="email"
                    :rules="emailRules"
                    label="Email Address"
                    @input="convertToLowercase"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-btn
                    small
                    class="primary mr-1"
                    rounded
                    @click="login()"
                    >Login</v-btn
                  >
                  <v-btn
                    :loading="loading"
                    small
                    :disabled="!packageOnevalid"
                    class="primary ml-1"
                    rounded
                    @click="checkIfUserExist()"
                    >Create Account</v-btn
                  >
                </v-col>
                <v-col cols="12">
                  <v-btn 
                    @click="privacyPolicy('https://compeat.social/privacy-policy/')"
                    rounded 
                    small 
                    text 
                    color="pink"
                    class="black--text">
                    Privacy Policy
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getFunctions, httpsCallable } from "firebase/functions";
import { firebaseApp } from "../firebaseConfig";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  doc,
  getDoc,
} from "firebase/firestore";
const db = getFirestore(firebaseApp);
import generalAlert from '../components/alerts/generalAlert.vue'

export default {
  props:['title'],
    components:{
        generalAlert
    },
  data: () => ({
    //Package 1 form v-model
    packageOnevalid: false,
    //form fields
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
    //agency varibles
    agencyProfile:[],
    //Rules for fields
    textRules: [(v) => !!v || "Field is required"],
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    //error varibles
    overlay:false,
    overlayError:false,
    catchErrorMessage:'',

    //alert varibles
    alert:false,
    alertType:'',
    successResponse:'',

    //loaders varible
    loading:false,
    package:'No Package'
  }),
  created(){
    this.getAgencyInfo()
  },
  methods: {
        // Gets if user email is in our system
    async checkIfUserExist() {
      this.loading = true;
      const q = query(
        collection(db, "users"),
        where("email", "==", this.email)
      );
      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty == true) {
        console.log("New User");
        this.createNewFirebaseUser();
      } else {
        console.log("Already A user");
        this.alert = true
        this.alertType = 'error'
        this.successResponse='User Already Exists with this email.'
        setTimeout(() => {
        this.alert = false
        this.alertType = ''
        this.successResponse=''
        }, 3000); // Change the timeout value to match your app's loading time

      }
    },
    //Gets agency info if client has been cleared with facebook verification
    async getAgencyInfo() {
        try {
          const docRef = doc(db, "agencies", 'S83EWuzohPa3tVb98qjT');
          const docSnap = await getDoc(docRef);
  
          if (docSnap.exists()) {
            this.agencyProfile = docSnap.data();
            this.overlay = false;
          } else {
            console.log("No such document!");
            this.overlay = false;
          }
        } catch (err) {
          console.log("getAgencyInfo err", err);
          this.overlay = false;
        }
      },
    //Generate password for new Subscriber
    generateRandomPassword() {
      const length = 12;
      const charset =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      let newPassword = "";

      for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * charset.length);
        newPassword += charset.charAt(randomIndex);
      }

      this.password = newPassword
      return this.password
    },
    //Create New User in firebase
    createNewFirebaseUser() {

      if(this.title != null){
        this.package = this.title
      }

      console.log('this.package',this.package)

      const functions = getFunctions(firebaseApp, "europe-west2");
      const createSubscriptionUser = httpsCallable(
        functions,
        "createSubscriptionUser"
      );

      createSubscriptionUser({
        name: this.firstName + " " + this.lastName,
        email: this.email,
        password: this.generateRandomPassword(),
        mobile: this.mobile,
        userType: "SB",
        agency: this.agencyProfile.agencyId,
        facebookToken: "",
        package:this.package
      })
        .then((result) => {
          console.log("createSubscriptionUser.result", result);
          if (
            result.data.httpErrorCode != null &&
            result.data.httpErrorCode.status == 500
          ) {
            this.loading = false;
            this.overlayError = true;
            this.catchErrorMessage = result.data.response.httpErrorCode.status;
          } else {
            this.emailSubscriberAccountDetails()
            // this.currentSubscriber = result.data.response;
            // console.log('User was created', result)
            // this.alert = true
            // this.alertType = 'success'
            // this.successResponse =' User was successfully created. Account details have been emailed.'
            // setTimeout(() => {
            // this.alert = false
            // this.alertType = ''
            // this.successResponse=''
            // }, 3000); // Change the timeout value to match your app's loading time
          }
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = false;
          this.overlayError = true;
          this.catchErrorMessage =
            error.message + " Please check all fields are correct";
        });
    },
    emailSubscriberAccountDetails(){
      // emailSubscriberAccountDetails
      const functions = getFunctions(firebaseApp, "europe-west2");
      const emailSubscriberAccountDetails = httpsCallable(
        functions,
        "emailSubscriberAccountDetails"
      );

      emailSubscriberAccountDetails({
        subscriberName: this.firstName + " " + this.lastName,
        subscriberEmail: this.email,
        subscriberPassword: this.password,
        agency: this.agencyProfile,
      })
        .then((result) => {
          console.log("Email result", result);
          if (
            result.data.httpErrorCode != null &&
            result.data.httpErrorCode.status == 500
          ) {
            this.loading = false;
            this.overlayError = true;
            this.catchErrorMessage = result.data.response.httpErrorCode.status;
          } else {
            // this.currentSubscriber = result.data.response;
            console.log('User was created', result)
            this.loading = false
            this.alert = true
            this.alertType = 'success'
            this.successResponse =' User was successfully created. Account details have been emailed.'
            setTimeout(() => {
            this.alert = false
            this.alertType = ''
            this.successResponse=''
            this.$router.push('/login')
            }, 3000); // Change the timeout value to match your app's loading time
          }
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = false;
          this.overlayError = true;
          this.catchErrorMessage =
            error.message + " Please check all fields are correct";
        });
    },
    // Valids Form
    validatePackageOneAndTwo() {
      this.$refs.packageOneForm.validate();
    },
    //Formats the number in the mobile field
    onInput(formattedNumber, { number }) {
      this.mobile = number.international;
    },
    //For email field
    convertToLowercase() {
      this.email = this.email.toLowerCase(); // Transform input to lowercase
    },
    login(){
      this.$router.push('/login')
    },
    privacyPolicy(url){
        window.open(url, '_blank');
    }
  },
};
</script>

<style>
.createccountbg{
    /* background-image: url('https://danetopham.co.za/images/backgroundcreataccount.jpeg'); */
    background-size: cover;
    background-repeat: no-repeat;
    animation: rotateBackground 30s infinite;
}

@keyframes rotateBackground {
  0% {
    background-image: url('https://danetopham.co.za/images/backgroundcreataccount.jpeg');
  }
  20% {
    background-image: url('https://danetopham.co.za/images/Untitled-2.jpg');
  }
  40% {
    background-image: url('https://danetopham.co.za/images/Woman1.jpg');
  }
  60% {
    background-image: url('https://danetopham.co.za/images/backgroundcreataccount.jpeg');
  }
  80% {
    background-image: url('https://danetopham.co.za/images/Untitled-2.jpg');
  }
  100% {
    background-image: url('https://danetopham.co.za/images/Woman1.jpg');
  }
}
</style>
